module.exports = "<div class=\"banner banner_cont2\">\n    <div class=\"path hidden-lg hidden-md hidden-sm\"><a routerLink=\"/tw\">首頁</a> > <a routerLink=\"./\">成立宗旨</a></div>\n</div>\n<div class=\"wrap container\">\n  <div class=\"path\"><a routerLink=\"/tw\">首頁</a> > <a routerLink=\"./\">成立宗旨</a></div>\n  <div class=\"title\">\n    <h2>成立宗旨</h2>\n    <hr>\n  </div>\n  <div class=\"wrap_content\">\n      <div [innerHtml]=\"content | SafeHtml\" class=\"innerHtmlcontent\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tw/about/about.component.html
// module id = 1020
// module chunks = 5